import { formatDistanceToNow } from 'date-fns';

export const formatMessageTime = (value: unknown): string => {
  try {
    const date = value instanceof Date ? value : new Date(value as any);
    if (Number.isNaN(date.getTime())) {
      return 'just now';
    }
    return formatDistanceToNow(date, { addSuffix: true });
  } catch {
    return 'just now';
  }
};

